<main class="editor-container">
  <article>
    <!--    <div class="leaning info-button" (click)="onInfoButtonClick()">-->
    <!--      <div class="content">-->
    <!--        <img src="/assets/photos/info-button.png" alt="Informacje o palecie">-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="info-desc-bg" [ngStyle]="{'display': paletteDesc ? 'block' : 'none'}" (click)="onInfoButtonClick()">-->
    <!--    </div>-->
    <!--    <div class="leaning palette-desc" [ngStyle]="{'display': paletteDesc ? 'block' : 'none'}"-->
    <!--         (click)="onInfoButtonClick()">-->
    <!--      <div class="content">{{styles.selected.palette.description}}</div>-->
    <!--    </div>-->
    <section class="editor">
      <div class="img-clip" #imgclip>
        <img src="{{project.orgImageFile}}" alt="" id="project-image" (window:resize)="onResize($event)">
        <canvas id="project-viewport" class="remains" (click)="onCanvasClick($event)" width="1175" height="700" #projectcanvas
                (mouseover)="onMouseOver($event)" (mousedown)="onMouseDown($event)" (mouseup)="onMouseUp($event)"
                (mouseleave)="onMouseLeave($event)" (mousemove)="onMouseMove($event)" (touchmove)="onMouseMove($event)" (touchstart)="onTouchStart($event)" (touchend)="onMouseUp($event)"></canvas>
      </div>
    </section>



    <ul class="palettes">
      <li *ngFor="let item of styles.items" [ngClass]="{'selected': styles.selected==item}" (click)="onStyleClick(item)"
          class="{{item.class}}" style="position: relative"

          matTooltip="{{item.description}}" placement="right"
          mdbWavesEffect

      >{{item.name}}


      </li>
    </ul>


    <div class="mobile-tabs">
      <div [ngClass]="{'active': mobileActionActive==0}" (click)="onMobileActionActive(0)"  >Powierzchnie</div>
      <div [ngClass]="{'active': mobileActionActive==1}" (click)="onMobileActionActive(1)"  >Palety</div>

      <div [ngClass]="{'active': mobileActionActive==2}" (click)="onMobileActionActive(2)"  >Akcje</div>
    </div>

    <section class="colors-section" [ngClass]="{'tab-active': mobileActionActive==1}">

      <div class="color-set">
        <h3>{{styles.selected.name}} <span   *ngIf="!isAllPalettesSelected()">- CAŁA PALETA KOLORYSTYCZNA</span> </h3>
        <div class="leaning info-button allcolors-tip" (mouseover)="onToolTip('all')" (mouseout)="onToolTip('')"
             [ngStyle]="{'display': isAllPalettesSelected() && !isMobile() ? 'flex': 'none'}">
          <div class="content"><img src="assets/photos/info-button.png" alt="Informacje o palecie"></div>
        </div>
        <div class="leaning info-tip allcolors-info" [ngStyle]="{'display': showInfo == 'all' ? 'block' : 'none'}">
          <div class="content"  >Pełna paleta kolorów tynków Knauf – prawie 800 odcieni, które możesz ze sobą
            dowolnie
            zestawiać i komponować. </div>
        </div>

        <div class="colors basic" [ngClass]="{'allcolors': isAllPalettesSelected(), 'active': mobileColorsActive==0}">
          <!--          <div class="leaning info-button" (mouseover)="onToolTip('basic')" (mouseout)="onToolTip('')">-->
          <!--            <div class="content"><img src="assets/photos/info-button.png" alt="Informacje o palecie"></div>-->
          <!--          </div>-->
          <!--          <div class="leaning info-tip" [ngStyle]="{'display': showInfo == 'basic' ? 'block' : 'none'}">-->
          <!--            <div class="content"  >Zastosuj je na dużych powierzchniach elewacji</div>-->
          <!--          </div>-->
          <h4   *ngIf="!isAllPalettesSelected()" (click)="mobileSelectColorsActive(0)">Kolory podstawowe</h4>
          <a  mdbBtn floating="true" class="tip" color="info"
              matTooltip="Zastosuj je na dużych powierzchniach elewacji"
              placement="left" mdbWavesEffect>
<!--            <mdb-icon fas icon="info"></mdb-icon>-->
          </a>
          <div class="blocks">
            <span *ngFor="let color of styles.selected.palette.basic" [ngStyle]="{'background': color.rgb}"
                  [title]="color.code" (click)="selectColor(color)"></span>
          </div>
        </div>

        <div class="colors extended" *ngIf="!isAllPalettesSelected()" [ngClass]="{'active': mobileColorsActive=='1'}">
          <!--          <div class="leaning info-button" (mouseover)="onToolTip('extended')" (mouseout)="onToolTip()">-->
          <!--            <div class="content"><img src="assets/photos/info-button.png" alt="Informacje o palecie"></div>-->
          <!--          </div>-->
          <!--          <div class="leaning info-tip" [ngStyle]="{'display': showInfo == 'extended' ? 'block' : 'none'}">-->
          <!--            <div class="content"  >Zastosuj je jako dopełnienie koloru podstawowego na mniejszej powierzchni</div>-->
          <!--          </div>-->

          <h4   (click)="mobileSelectColorsActive(1)">Kolory uzupełniające</h4>
          <a  mdbBtn floating="true" class="tip" color="info"
              matTooltip="Zastosuj je jako dopełnienie koloru podstawowego na mniejszej powierzchni"
              placement="left" mdbWavesEffect>
            <mdb-icon fas icon="info"></mdb-icon>
          </a>
          <div class="blocks">
            <span *ngFor="let color of styles.selected.palette.extended" [ngStyle]="{'background': color.rgb}"
                  [title]="color.code" (click)="selectColor(color)"></span>
          </div>
        </div>

        <div class="colors accent" *ngIf="!isAllPalettesSelected()" [ngClass]="{'active': mobileColorsActive==2}">
          <!--          <div class="leaning info-button" (mouseover)="onToolTip('accent')" (mouseout)="onToolTip('')">-->
          <!--            <div class="content"><img src="assets/photos/info-button.png" alt="Informacje o palecie"></div>-->
          <!--          </div>-->
          <!--          <div class="leaning info-tip" [ngStyle]="{'display': showInfo == 'accent' ? 'block' : 'none'}">-->
          <!--            <div class="content"  >Zastosuj je do podkreślenia niewielkich fragmentów elewacji</div>-->
          <!--          </div>-->

          <a  mdbBtn floating="true" class="tip" color="info"  matTooltip="Zastosuj je do podkreślenia niewielkich fragmentów elewacji" placement="left" mdbWavesEffect>
            <mdb-icon fas icon="info"></mdb-icon>
          </a>

          <h4   (click)="mobileSelectColorsActive(2)">Akcenty</h4>

          <div class="blocks"><span *ngFor="let color of styles.selected.palette.accent"
                                    [ngStyle]="{'background': color.rgb}" [title]="color.code" (click)="selectColor(color)"></span>
          </div>
        </div>
      </div>
    </section>



    <aside>
      <div class="surfaces" [ngClass]="{'tab-active': mobileActionActive==0}">

        <div class="surface-actions">

          <!--          <button (click)="toolSelect()" [ngClass]="{'selected': editorTool == EditorTool.Select}"><img class="tool" src="assets/ikony/draw.png"></button>-->
          <a (click)="toolSelect()" [ngClass]="{'selected': editorTool == EditorTool.Select}"  matTooltip="Rysuj powierzchnię" matTooltipPosition="above"><img class="tool" src="assets/ikony/draw2.png"></a>
          <a class="tool-btn clear icobtn" (click)="addProjectToCompare()"  matTooltip="Zapisz pracę/Dodaj do Moje projekty" matTooltipPosition="above"><fa-icon [icon]="faDownload"></fa-icon></a>

          <a (click)="toolCut()" matTooltip="Wytnij okna/drzwi w zaznaczonej powierzchni" matTooltipPosition="above" [ngClass]="{'selected': editorTool == EditorTool.Cut}" [ngStyle]="{'visibility': selectedLayers()==1 ? 'visible' : 'hidden'}"><img class="tool" src="assets/ikony/cut.png"></a>


          <!--          <button (click)="toolMove()" [ngClass]="{'selected': editorTool == EditorTool.Move}" [ngStyle]="{'display': zoom > 1 ? 'block' : 'none'}"><img class="tool" src="assets/ikony/aplikacja-ikony-11.png"></button>-->

          <!-- nowe buttony wstępne do dowania / odejmowania punktów -->
          <a class="tool-btn plus icobtn" (click)="toolAddPoint()" matTooltip="Dodaj punkty na linii" matTooltipPosition="below" [ngClass]="{'selected': editorTool == EditorTool.AddPoint}" [ngStyle]="{'visibility': selectedLayers()==1 ? 'visible' : 'hidden'}"><fa-icon class="tool" [icon]="faPlusCircle"></fa-icon></a>
          <a class="tool-btn clear icobtn" (click)="toolDeletePoint()" matTooltip="Usuń punkty" matTooltipPosition="below" [ngClass]="{'selected': editorTool == EditorTool.DelPoint}" [ngStyle]="{'visibility': selectedLayers()==1 ? 'visible' : 'hidden'}"><fa-icon class="tool" [icon]="faMinusCircle"></fa-icon></a>

          <a (click)="toolMove()" matTooltip="Przesuń kompozycję" matTooltipPosition="above" [ngClass]="{'selected': editorTool == EditorTool.Move}" [ngStyle]="{'display': zoom > 1 ? 'block' : 'none'}"><img class="tool" src="assets/ikony/aplikacja-ikony-11.png"></a>


          <a class="tool-btn back icobtn" (click)="goBack()" style="clear:both;" matTooltip="Cofnij ostatni krok" matTooltipPosition="below"><fa-icon  id="goback"  [icon]="faUndo"></fa-icon></a>
          <a class="tool-btn forward icobtn" (click)="goForward()" matTooltip="Przywróć ostatni krok" matTooltipPosition="below"><fa-icon [icon]="faRedo"></fa-icon></a>

          <a class="tool-btn clear icobtn" (click)="onResetEditor()"   placement="top" matTooltip="Wymaż wszystkie działania" matTooltipPosition="above"><fa-icon [icon]="faEraser"></fa-icon></a>
          <a class="tool-btn plus icobtn" (click)="zoomIn()" matTooltip="Powiększ zdjęcie" matTooltipPosition="below"><fa-icon [icon]="faSearchPlus"></fa-icon></a>
          <a class="tool-btn clear icobtn" (click)="zoomOut()" matTooltip="Pomniejsz zdjęcie" matTooltipPosition="below"><fa-icon [icon]="faSearchMinus"></fa-icon></a>
          <a class="tool-btn clear icobtn" (click)="preview()" matTooltip="Podgląd projektu" matTooltipPosition="below"><fa-icon [icon]="faEye"></fa-icon></a>


        </div>

        <div class="in help-info">
          <ng-template #popTemplate> <div class="edit-info" >

            <ul>
              <li><mdb-icon fas icon="paint-brush"></mdb-icon> Rysuj nową powierzchnię</li>
              <li><mdb-icon fas icon="eraser"></mdb-icon> Wymaż wszystkie działania</li>
              <li><mdb-icon fas icon="cut"></mdb-icon>Wytnij otwory (np. okna/drzwi) w aktywnej powierzchni</li>
              <li><mdb-icon fas icon="plus-circle"></mdb-icon>Aby dodać punkt, kliknij w dowolną linię</li>
              <li><mdb-icon fas icon="minus-circle"></mdb-icon>Aby usunąć punkt, kliknij w niego</li>
              <li><mdb-icon fas icon="hand-paper"></mdb-icon>Umożliwia przesunięcie kompozycji przy powiększeniu obrazu</li>
              <li><mdb-icon fas icon="file-download"></mdb-icon>Umożliwia zapisanie Twojej pracy w MOJE PROJEKTY</li>
              <li><mdb-icon fas icon="square"></mdb-icon> Zaznacz w kratkach powierzchnie, aby zmieniać im kolory</li>
              <li><mdb-icon fas icon="times"></mdb-icon> Kliknij x aby usunąć powierzchnię</li>


              <li><mdb-icon fas icon="circle"></mdb-icon>  Złap punkt na zaznaczonej powierzchni aby go przesunąć</li>
            </ul>


          </div></ng-template>
          <button
            type="button"
            floating="true"
            mdbBtn
            size="sm"
            placement="left"
            color="info"
            class="tip">
<!--            [matTooltip]="popTemplate"-->
<!--            mdbWavesEffect-->

<!--            <mdb-icon fas icon="info"></mdb-icon>-->
          </button>


          <!--          <div class="leaning info-button" (mouseover)="onToolTip('layers')" (mouseout)="onToolTip('')">-->
          <!--            <div class="content"><img src="assets/photos/info-button.png" alt="Informacje o palecie"></div>-->
          <!--          </div>-->
          <!--          <div class="leaning info-tip biginfo" [ngStyle]="{'display': showInfo == 'layers' ? 'block' : 'none'}">-->
          <!--            <div class="content"  >-->
          <!--              <ul>-->
          <!--                <li>Zaznacz w kratkach powierzchnie, aby zmieniać im kolory</li>-->
          <!--                <li>Kliknij x aby usunąć powierzchnię</li>-->
          <!--                <li>Kliknij w strzałkę żeby rysować powierzchnie</li>-->
          <!--                <li>Zaznacz nożyczki, aby wyciąć okna/drzwi w zaznaczonej powierzchni</li>-->
          <!--                <li>Złap punkt na zaznaczonej powierzchni aby go przesunąć</li>-->
          <!--              </ul>-->
          <!--            </div>-->
          <!--          </div>-->
          <h3  >Powierzchnie</h3>
        </div>
        <h4 *ngIf="layers.length==0" class="no-surfaces"  ><strong>Nie dodałeś jeszcze żadnych powierzchni.</strong><br/><br/>
          Kliknij ikonkę pędzla, by wyznaczyć swoje powierzchnie.<br/><br/>
          Kliknij w POWIERZCHNIE, żeby nadać jej swoją nazwę.</h4>
        <ul>
          <li *ngFor="let layer of layers.slice().reverse() ; let i = index">
            <div>
              <span class="color" [ngStyle]="{'background-color': layer.color ? layer.color.rgb : '#fff'}" [title]="layer.color ? layer.color.code : ''"></span>
              <span class="select" [ngClass]="{'selected': layer.selected }" (click)="selectLayer(layer)"></span>
              <span class="layer-name" (dblclick)="onLayerNameChange(layers[layers.length-i], layers.length-i -1)"   *ngIf="layer.name == null">Powierzchnia {{ layers.length- i}}</span>
              <span class="layer-name" (dblclick)="onLayerNameChange(layers[layers.length-i], layers.length-i -1)"   *ngIf="layer.name != null">{{ layer.name}}</span>
              <!--              <span class="clear-button" (click)="clearLayer(layer)"><mdb-icon fas icon="times"></mdb-icon></span>-->
              <span class="clear-button" (click)="onClearLayer(layer)">x</span>
            </div>
            <div class="slider-container">
              <div *ngIf="layer.selected" class="">
                <!--              <mdb-icon fas icon="sun"></mdb-icon>-->
                <mdb-range-input (rangeValueChange)="onLayerOpacityChanged($event, layer)" class="w-100 slider" id="range" min="0" max="100" value="{{layer.opacity}}"></mdb-range-input>
                <!--              <mdb-icon far icon="sun"> </mdb-icon>-->
              </div>
            </div>
          </li>
        </ul>

      </div>
      <div class="actions" [ngClass]="{'tab-active': mobileActionActive==2}">
        <div style="padding: 1em">



          <app-footer [next]="next" [nextEvent]="true" (clickNext)="onNextClick($event)"></app-footer>
        </div>
      </div>


    </aside>


  </article>
</main>







<jw-modal id="preview-dialog">
  <span class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
                                     (click)="closeModal('preview-dialog')"></span>
  <img src="" alt="Podgląd projektu" class="preview-image">
</jw-modal>

<jw-modal id="warning-dlg">
  <div class="warningdlg messagebox">
    <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
                                         (click)="closeModal('warning-dlg')"></button>
    <p  >Możesz dodać jedynie 2 projekty do porównania. Jeżeli chcesz dodać kolejny, przejdź do widoku "Moje
      projekty" i usuń któryś z już istniejących.</p>
    <div class="buttons">
      <button class="accept leaning" (click)="goToMyProjects()">
        <div class="content"><img src="assets/ikony/aplikacja-ikony-13.png">
          <div>Przejdź do moich projektów</div>
        </div>
      </button>
      <button class="accept leaning" (click)="closeModal('warning-dlg')">
        <div class="content"><img src="assets/ikony/aplikacja-ikony-13.png">Anuluj</div>
      </button>
    </div>
  </div>
</jw-modal>

<jw-modal id="confirmation-dlg">
  <div class="messagebox">
    <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
                                         (click)="closeModal('confirmation-dlg')"></button>
    <p  >Twój projekt został dodany do porównania</p>
    <div class="buttons">
      <button class="accept leaning" (click)="closeModal('confirmation-dlg')">
        <div class="content"><img src="assets/ikony/aplikacja-ikony-13.png">OK</div>
      </button>
    </div>
  </div>
</jw-modal>

<jw-modal id="editname-dlg">
  <div class="messagebox">
    <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
                                         (click)="closeModal('editname-dlg')"></button>
    <p  >Zmień nazwę powierzchni</p>
    <p>
      <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="layername">
    </p><div class="buttons">
    <button class="accept leaning" (click)="changeName()">
      <div class="content"><img src="assets/ikony/aplikacja-ikony-13.png">Zapisz</div>
    </button>
    <button class="accept leaning" (click)="closeModal('editname-dlg')">
      <div class="content"><img src="assets/ikony/aplikacja-ikony-16.png">Anuluj</div>
    </button>
  </div>
  </div>
</jw-modal>

<jw-modal id="delete-dlg">
  <div class="messagebox">
    <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
                                         (click)="closeModal('delete-dlg')"></button>
    <p  >Usunąć poprzednie działania?</p>
    <div class="buttons">
      <button class="accept leaning" (click)="resetEditor()">
        <div class="content"><img src="assets/ikony/aplikacja-ikony-18.png">Usuń</div>
      </button>
      <button class="accept leaning" (click)="closeModal('delete-dlg')">
        <div class="content"><img src="assets/ikony/aplikacja-ikony-16.png">Anuluj</div>
      </button>
    </div>
  </div>
</jw-modal>


<jw-modal id="delete-layer-dlg">
  <div class="messagebox">
    <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
                                         (click)="closeModal('delete-layer-dlg')"></button>
    <p  >Czy na pewno chcesz usunąć powierzchnię?</p>
    <div class="buttons">
      <button class="accept leaning" (click)="clearLayer()">
        <div class="content"><img src="assets/ikony/aplikacja-ikony-18.png">Usuń</div>
      </button>
      <button class="accept leaning" (click)="closeModal('delete-layer-dlg')">
        <div class="content"><img src="assets/ikony/aplikacja-ikony-16.png">Anuluj</div>
      </button>
    </div>
  </div>
</jw-modal>
